import { FC } from 'react'

const StockingFrogiesDefinition: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
    <symbol id="stocking-frogies-icon-definition">
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="8px"
      >
        <path d="M4,9.84V143.2c0,5.96,4.83,10.8,10.8,10.8h0c5.96,0,10.8-4.83,10.8-10.8V63.13c0-3.06,2.48-5.54,5.54-5.54h0c3.06,0,5.54,2.48,5.54,5.54v80.07c0,5.96,4.83,10.8,10.8,10.8h0c5.96,0,10.8-4.83,10.8-10.8V9.84H4Z" />
        <rect x="4" y="4" width="54.28" height="5.84" />
        <line x1="31.14" y1="4" x2="31.14" y2="57.59" />
      </g>
    </symbol>
  </svg>
)

export default StockingFrogiesDefinition
